export default import.meta.ROLLDOWN_FILE_URL_OuWTX4Ox4l3mL6WWT6fbrQ